import { FieldProps, getIn } from 'formik';
import React, { FC }         from 'react';
import { NumberInput }       from '../inputs/NumberInput';

interface IProps extends FieldProps {
  id?: string;
  error?: boolean;
}

export const NumberInputField: FC<IProps> = ({
  form,
  field,
  ...props
}) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <NumberInput
      {...field}
      {...props}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
    />
  );
};
